import { isNil } from "lodash";
import type { DateTime } from "./date";
import type { nil } from "./type-utils";

interface RankedVerification {
  level: CandidateVerificationLevel;
  verifiedAt: DateTime;
}

export enum CandidateVerificationLevel {
  AES = "AES",
  QES = "QES",
}

const verificationLevelRank: Record<CandidateVerificationLevel, number> = {
  [CandidateVerificationLevel.AES]: 1,
  [CandidateVerificationLevel.QES]: 2,
};

export function getVerificationLevelRank(level: CandidateVerificationLevel): number {
  return verificationLevelRank[level];
}

export function supersedesVerification(incoming: RankedVerification, stored: RankedVerification | nil): boolean {
  if (isNil(stored)) {
    return true;
  }

  const incomingRank = verificationLevelRank[incoming.level];
  const storedRank = verificationLevelRank[stored.level];
  if (incomingRank !== storedRank) {
    return incomingRank > storedRank;
  }

  return incoming.verifiedAt.toEpochMillis() < stored.verifiedAt.toEpochMillis();
}
